import { generatePath } from 'react-router-dom'

export const API_METHODS = { POST: 'POST', GET: 'GET', PUT: 'PUT', DELETE: 'DELETE' }

export const routes = {
    homeIndex: { path: '/', label: 'Home', component: 'Home' },

    clayvilleIndex: { path: '/clayville/', label: 'Clayville', component: 'Clayville' },
    clayvilleView: { path: '/clayville/:location/', label: 'Clayville View', component: 'Clayville Location' },

    murphysIndex: { path: '/tales-from-the-east-side/', label: 'Tales from the East Side', component: 'Murphys' },
    murphysView: { path: '/tales-from-the-east-side/:character/:chapterId?', label: 'Story', component: 'Character Story' },

    keyIssuesIndex: { path: '/key-issues/', label: 'Key Issues', component: 'Key Issues' },
    keyIssueOverview: { path: '/key-issues/:keyIssueSlug/', label: 'Key Issue Overview', component: 'Key Issue Overview' },
    keyIssueView: { path: '/key-issues/:keyIssueSlug/in-depth', label: 'Key Issue View', component: 'Key Issue View' },

    resourcesIndex: { path: '/resources/', label: 'Resources', component: 'Resources' },

    siteGuidesIndex: { path: '/site-guides/', label: 'Site Guides', component: 'Site Guides' },

    contentPage: { path: '/content/:slug/', label: 'Content Page', component: 'Content Page' },

    systemicRacismExplained: { path: '/systemic-racism-explained/', label: 'Systemic Racism Explained', component: 'Content Page' },

    about: { path: '/about/', label: 'About', component: 'Content Page' },

    whyWeAreHere: { path: '/why-we-are-here/', label: 'Why We Are Here', component: 'Content Page' },

    community: { path: '/stay-in-touch/', label: 'Stay in Touch', component: 'Content Page' },

    spiritStaysFree: { path: '/spirit-stays-free/', label: 'Spirit Stays Free', component: 'Content Page' },

    clayvilleGameHowToPlay: { path: '/clayville-game-how-to-play/', label: 'Clayville Game How to Play', component: 'Content Page' },

    privacyPolicy: { path: '/privacy-policy/', label: 'Privacy Policy', component: 'Content Page' },

    termsOfService: { path: '/terms-service/', label: 'Terms of Service', component: 'Content Page' },

    cookiePolicy: { path: '/cookie-policy/', label: 'Cookie Policy', component: 'Content Page' },

    styleGuideIndex: { path: '/style-guide/', label: 'Style Guide', component: 'Style Guide' },

    router: { path: '/router/', label: '' },

    registerAuth: { path: '/auth-registration/', label: 'Auth Registration' },

    authLogin: { path: '/login/', label: 'Login' },
    authLogout: { path: '/logout/', label: 'Logout' },
    authRegister: { path: '/register/', label: 'Register' },
    authPasswordHelp: { path: '/password-help/', label: 'Password Help' },
    authPasswordReset: { path: '/password-reset/', label: 'Password Reset' },
    authHandler: { path: '/auth-handler/', label: '' },

    modalSample: { path: '/:pagePath*/m/sample/', label: '' }
}

// chapterId value used for the final slide of a character story (field_character_wrap_up)
export const WRAP_UP_SLUG = 'making-a-way-out-of-no-way'

export const apiResourceEndpoint = (resource, action, id = null, extraPath = '') => {
    let routeObj = {
        url: `/${resource}/`,
        method: API_METHODS.GET
    }
    // adjust the route
    if (action === 'UPDATE' || action === 'VIEW' || action === 'DELETE') {
        routeObj.url = routeObj.url + `${id}/`
    }
    // adjust the medthod
    if (action === 'CREATE' || action === 'UPDATE') {
        routeObj.method = API_METHODS.POST
    } else if (action === 'DELETE') {
        routeObj.method = API_METHODS.DELETE
    }
    // do we need to append any extra stuff to the url
    if (extraPath !== '') {
        routeObj.url = routeObj.url + extraPath + '/'
    }
    return routeObj
}

export const nestedRoutePath = (parent, route, isParent = false) => {
    let nestedRoute = route.substr(parent.length)
    if (isParent) {
        nestedRoute = nestedRoute + '*'
    }
    return nestedRoute
}

export const buildRoutePath = (route, params = {}, urlParams = {}) => {
    let query = ''
    query = Object.keys(urlParams).map(key => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(urlParams[key])
    }).join('&')
    if (query !== '') {
        query = '?' + query
    }
    return generatePath(route, params) + query
}
